import React, { createContext, useContext, useState } from 'react';

const translations = {
  no: {
    // Navigation
    home: 'Hjem',
    menu: 'Meny',
    about: 'Om oss',
    contact: 'Kontakt',
    
    // Hero
    heroTitle: 'Smakglød Torp',
    heroSubtitle: 'Pizza og Grill',
    heroDescription: 'Opplev smaken av ekte italiensk pizza og deilig grillmat laget med kjærlighet og ferske ingredienser.',
    viewMenu: 'Se meny',
    orderNow: 'Bestill nå',
    
    // Menu
    menuTitle: 'Vår Meny',
    menuSubtitle: 'Utforsk vårt utvalg av deilige retter',
    allCategories: 'Alle',
    currency: 'kr',
    
    // About
    aboutTitle: 'Om Oss',
    aboutSubtitle: 'Vår Historie',
    aboutText1: 'Smakglød Torp har servert den beste pizzaen, burgere og kebab i Torp-området siden vi åpnet dørene. Vi er stolte av å bruke ferske ingredienser av høy kvalitet i alle våre retter.',
    aboutText2: 'Vårt lidenskapelige team jobber hardt hver dag for å gi deg en uforglemmelig matopplevelse. Enten du kommer innom for en rask lunsj eller en hyggelig middag med familien, er du alltid velkommen hos oss.',
    ourValues: 'Våre Verdier',
    quality: 'Kvalitet',
    qualityDesc: 'Kun de beste ingrediensene',
    fresh: 'Fersk',
    freshDesc: 'Laget fersk hver dag',
    local: 'Lokalt',
    localDesc: 'Stolt lokal bedrift',
    
    // Contact
    contactTitle: 'Kontakt Oss',
    contactSubtitle: 'Vi vil gjerne høre fra deg',
    yourName: 'Ditt navn',
    yourEmail: 'Din e-post',
    yourPhone: 'Ditt telefonnummer (valgfritt)',
    yourMessage: 'Din melding',
    sendMessage: 'Send melding',
    messageSent: 'Melding sendt!',
    messageError: 'Noe gikk galt. Prøv igjen.',
    
    // Opening hours
    openingHours: 'Åpningstider',
    monday: 'Mandag',
    tuesday: 'Tirsdag',
    wednesday: 'Onsdag',
    thursday: 'Torsdag',
    friday: 'Fredag',
    saturday: 'Lørdag',
    sunday: 'Søndag',
    
    // Footer
    address: 'Adresse',
    followUs: 'Følg oss',
    allRights: 'Alle rettigheter reservert',

    // 404
    notFoundTitle: 'Siden finnes ikke',
    notFoundDescription: 'Adressen du prøvde å åpne eksisterer ikke. Kanskje du fant deg på feil sted – la oss ta deg tilbake til forsiden.',
    notFoundGoHome: 'Til forsiden',
  },
  en: {
    // Navigation
    home: 'Home',
    menu: 'Menu',
    about: 'About',
    contact: 'Contact',
    
    // Hero
    heroTitle: 'Smakglød Torp',
    heroSubtitle: 'Pizza & Grill',
    heroDescription: 'Experience the taste of authentic Italian pizza and delicious grilled food made with love and fresh ingredients.',
    viewMenu: 'View Menu',
    orderNow: 'Order Now',
    
    // Menu
    menuTitle: 'Our Menu',
    menuSubtitle: 'Explore our selection of delicious dishes',
    allCategories: 'All',
    currency: 'kr',
    
    // About
    aboutTitle: 'About Us',
    aboutSubtitle: 'Our Story',
    aboutText1: 'Smakglød Torp has been serving the best pizza, burgers, and kebab in the Torp area since we opened our doors. We pride ourselves on using fresh, high-quality ingredients in all our dishes.',
    aboutText2: 'Our passionate team works hard every day to give you an unforgettable dining experience. Whether you stop by for a quick lunch or a cozy dinner with family, you are always welcome with us.',
    ourValues: 'Our Values',
    quality: 'Quality',
    qualityDesc: 'Only the finest ingredients',
    fresh: 'Fresh',
    freshDesc: 'Made fresh every day',
    local: 'Local',
    localDesc: 'Proud local business',
    
    // Contact
    contactTitle: 'Contact Us',
    contactSubtitle: 'We would love to hear from you',
    yourName: 'Your name',
    yourEmail: 'Your email',
    yourPhone: 'Your phone (optional)',
    yourMessage: 'Your message',
    sendMessage: 'Send Message',
    messageSent: 'Message sent!',
    messageError: 'Something went wrong. Please try again.',
    
    // Opening hours
    openingHours: 'Opening Hours',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    
    // Footer
    address: 'Address',
    followUs: 'Follow Us',
    allRights: 'All rights reserved',

    // 404
    notFoundTitle: 'Page not found',
    notFoundDescription: 'The address you tried to open does not exist. Perhaps you ended up in the wrong place – let us take you back to the home page.',
    notFoundGoHome: 'Go to home page',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('no');

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'no' ? 'en' : 'no');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
